import React, {Fragment, useEffect, useMemo, useState} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Card, Col, Modal, Row, Tooltip} from "antd";
import {
    GUTTER_MD,
    GUTTER_SM,
    MARGIN_MD,
    MODAL_WIDTH_SM,
    TABLE_COL_MIN_WIDTH_ID
} from "../../../../../styles/constants";
import {DOT_STAT_COLUMN_NAME} from "../../../../data-manager/file-mapping/wizard/reducer";
import {connect} from "react-redux";
import MappingSetWizardComponentList from "../components/MappingSetWizardComponentList";
import ObjectPreview from "../../../dataset-builder/modals/components/ObjectPreview";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import {
    clearMappingPreviewMappingSet,
    getMappingSetDeleteStashRow,
    readMappingSetWizardQueryColumnPreviewRows,
    readMappingSetWizardQueryPreviewRows, resetMappingSetValidations,
    selectMappingSetWizardColumn,
    selectMappingSetWizardDsdColumn,
} from "../actions";
import MappingSetWizardComponentMapper from "../components/MappingSetWizardComponentMapper";
import InfiniteScrollTable from "../../../../../components/infinite-scroll-table";
import {BUTTON_BLANK, BUTTON_CREATE, BUTTON_DELETE} from "../../../../../styles/buttons";
import _ from "lodash";
import ModalPreview from "../components/ModalPreview";
import {
    addStatusToStash,
    componentHasCodelist,
    checkSaveAndOpenModal,
    getCurrentTranscoding,
} from "../utils";
import EnhancedModal from "../../../../../components/enhanced-modal";
import AttributeDetailsMappingSet from "../components/AttributeDetailsMappingSet";
import {getArtefactTripletFromUrn} from "../../../../../utils/sdmxJson";
import {MM_CODELISTS_PREFIX} from "../../../../meta-manager/codelists/reducer";
import ReduxCodelistDetailModal from "../../../../../redux-components/redux-codelist-detail-modal";
import {reuseAction} from "../../../../../utils/reduxReuse";
import {editCodelistDetail} from "../../../../../redux-components/redux-codelist-detail-modal/actions";
import {MM_DSDS_PREFIX} from "../../../../meta-manager/dsds/reducer";
import ReduxDsdDetailModal from "../../../../../redux-components/redux-dsd-detail-modal";
import {editDsdDetail} from "../../../../../redux-components/redux-dsd-detail-modal/actions";
import ValidationAlert from "../components/ValidationAlert";
import {setTranscoding, deleteMapping} from "../../transcoding/actions";
import TranscodingDimension from '../../transcoding/settings/TranscodingDimension';
import TranscodingTimeDimension from '../../transcoding/settings/TranscondingTimeDimension';
import Simple01Transcoding from "../../transcoding/settings/Simple01Transcoding";
import SaveMappingWithNameAlert from "../components/SaveMappingWithNameAlert";
import {
    endQueryDBSpecific,
    wrapColumnWithDBSpecificParenthesis
} from "../../../dataset-builder/modals/components/utils";

const mapStateToProps = ({
                             scenes: {metaManager},
                             scenes: {mappingHandler: {mappingSet: {wizard, index, tree, transcoding}}},
                             scenes: {mappingHandler: {dataflowPublishing: {components}}}
                         }) => ({
    selectedDataset: wizard.selectedDataset,
    rows: wizard.rows,
    colRows: wizard.colRows,
    dsd: wizard.dsd,
    dsdTriplet: wizard.dsdTriplet,
    stash: wizard.stash,
    components: wizard.components,
    selectedConnection: wizard.selectedConnection,
    selectedColumnName: wizard.selectedColumnName,
    selectedDsdColumnName: wizard.selectedDsdColumnName,
    mappingSetPreview: wizard.mappingSetPreview,
    codelistDetail: metaManager.codelists.codelistDetail,
    dsdDetail: metaManager.dsds.dsdDetail,
    closeValidation: wizard.closeValidation,
    name: wizard.name,
    isStruvalPresent: wizard.isStruvalPresent,
    mappingSetPreviewToken: wizard.mappingSetPreviewToken,
});

const mapDispatchToProps = dispatch => ({
    fetchTableViewPreviewColumnRows: (colName) => ({
                                                       connId,
                                                       limit,
                                                       page,
                                                       query,
                                                       searchText,
                                                       filters,
                                                       sortCol,
                                                       sortByDesc,
                                                       rows
                                                   }) =>
        dispatch(readMappingSetWizardQueryColumnPreviewRows(connId, limit, page, query, searchText, getFilterObjFromViewerObj(rows && rows.columns, searchText, filters), sortCol, sortByDesc, colName)),
    fetchTableViewPreviewRows: ({
                                    connId,
                                    limit,
                                    page,
                                    query,
                                    searchText,
                                    filters,
                                    sortCol,
                                    sortByDesc,
                                    rows
                                }) =>
        dispatch(readMappingSetWizardQueryPreviewRows(connId, limit, page, query, searchText, getFilterObjFromViewerObj(rows && rows.columns, searchText, filters), sortCol, sortByDesc)),
    onColumnSelect: (columnName, multiplesAllowed) => dispatch(selectMappingSetWizardColumn(columnName, multiplesAllowed)),
    onDsdColumnSelect: (dsdColumnName, multiplesAllowed) => dispatch(selectMappingSetWizardDsdColumn(dsdColumnName, multiplesAllowed)),
    onDeleteStashRow: (row) => dispatch(getMappingSetDeleteStashRow(row)),
    onViewCodelistDetail: (codelistTriplet, defaultItemsViewMode) => dispatch(reuseAction(editCodelistDetail(codelistTriplet, defaultItemsViewMode), MM_CODELISTS_PREFIX)),
    onViewDsdDetail: dsdTriplet => dispatch(reuseAction(editDsdDetail(dsdTriplet), MM_DSDS_PREFIX)),
    onResetValidateMappingSet: () => dispatch(resetMappingSetValidations()),
    onTranscodingColumn: (item, isTimeDimension) => dispatch(setTranscoding(item, isTimeDimension)),
    onDeleteMapping: (mappingId, isTimeMapping) => dispatch(deleteMapping(mappingId, isTimeMapping)),
    clearPreview: (mappingSetPreviewToken) => dispatch(clearMappingPreviewMappingSet(mappingSetPreviewToken)),
});

const TABLE_HEIGHT = 123;
// 330px works with fullscreen modal
const MAPPING_BLOCKS_HEIGHT = `calc(100vh - 330px - ${TABLE_HEIGHT}px)`

const MappingSetDefinition = ({
                                  t,
                                  selectedDataset,
                                  rows,
                                  colRows,
                                  selectedConnection,
                                  selectedColumnName,
                                  selectedDsdColumnName,
                                  fetchTableViewPreviewRows,
                                  fetchTableViewPreviewColumnRows,
                                  onColumnSelect,
                                  onDsdColumnSelect,
                                  dsd,
                                  dsdTriplet,
                                  stash,
                                  components,
                                  mappingSetPreview,
                                  onDeleteStashRow,
                                  onViewCodelistDetail,
                                  onViewDsdDetail,
                                  codelistDetail,
                                  dsdDetail,
                                  closeValidation,
                                  onResetValidateMappingSet,
                                  onTranscodingColumn,
                                  onDeleteMapping,
                                  name,
                                  isStruvalPresent,
                                  mappingSetPreviewToken,
                                  clearPreview,
                              }) => {
    const [columnPreview, setColumnPreview] = useState(null);
    const [showDatasetPreview, setShowDatasetPreview] = useState(false);
    const [showMappingSetPreview, setShowMappingSetPreview] = useState(false);
    const [attribute, setAttribute] = useState(null);
    const [codelistTab, setCodelistTab] = useState("items");
    const [validationAlert, setValidationAlert] = useState(null);
    const [showSaveAlert, setShowSaveAlert] = useState(false);
    const [showSilentSaveAlert, setShowSilentSaveAlert] = useState(false);
    const [saveCallback, setSaveCallback] = useState(null);
    const [transcodingToBeOpened, setTranscodingToBeOpened] = useState(null);
    const needsToBeSaved = useMemo(() => !name, [name]);
    const needsToBeSavedSilently = useMemo(() => !!name && !!(stash || []).filter(row => !row.entityId).length, [name, stash]);

    useEffect(() => {
        if (transcodingToBeOpened && stash) {
            const currentTranscoding = getCurrentTranscoding(transcodingToBeOpened, stash)
            if (!!currentTranscoding.dsdCodelist || currentTranscoding.dsdType === 'TimeDimension' || !!currentTranscoding.constantValue) {
                onTranscodingColumn(currentTranscoding, currentTranscoding.dsdType === 'TimeDimension');
            }
            setTranscodingToBeOpened(null);
        }
    }, [transcodingToBeOpened, stash]);

    useEffect(() => {
        if (closeValidation) {
            setValidationAlert(null);
            setShowSaveAlert(false);
            setShowSilentSaveAlert(false);
            setSaveCallback(null);
            onResetValidateMappingSet();
        }
    }, [closeValidation]);

    const separateWordsByComma = (content) => {
        if (Array.isArray(content)) {
            return content.join(", ")
        } else {
            return content
        }
    }

    return (
        <Fragment>
            <Row gutter={GUTTER_MD} style={{marginBottom: GUTTER_MD, minHeight: "300px"}}>
                <Col span={7}>
                    <div style={{height: MAPPING_BLOCKS_HEIGHT}}>
                        <Card
                            title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.dataset.title')}
                            style={{height: "100%", minHeight: "300px"}}
                            bodyStyle={{height: "100%", minHeight: "300px"}}
                        >
                            <div style={{display: "flex", flexDirection: "column", height: "calc(100% - 40px)", gap: MARGIN_MD}}>
                                <ObjectPreview connId={selectedConnection ? selectedConnection.entityId : null}
                                               query={selectedDataset ? `SELECT DISTINCT ${wrapColumnWithDBSpecificParenthesis(columnPreview, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null)} FROM (${selectedDataset.query}) ${endQueryDBSpecific(selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null)}` : null}
                                               isRowsModalVisible={!!columnPreview}
                                               onRowsModalHide={() => setColumnPreview(null)}
                                               rows={colRows}
                                               fetchRows={fetchTableViewPreviewColumnRows(columnPreview)}
                                               title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.dataset.preview', {column: columnPreview})}
                                               width={MODAL_WIDTH_SM}
                                />
                                <MappingSetWizardComponentList
                                    components={
                                        selectedDataset && selectedDataset.columns
                                            ? (
                                                selectedDataset.columns.map((col, idx) => ({
                                                    name: col.name,
                                                    key: idx,
                                                    onDetail:
                                                        col.name !== DOT_STAT_COLUMN_NAME
                                                            ? () => setColumnPreview(col.name)
                                                            : null,
                                                    detailTitle: col.name !== DOT_STAT_COLUMN_NAME
                                                        ? t('scenes.mappingHandler.MappingSet.wizard.steps.second.dataset.detail.title')
                                                        : t('scenes.mappingHandler.MappingSet.wizard.steps.second.dataset.dotStatColumnDetail.title')
                                                }))
                                            )
                                            : []
                                    }
                                    selected={
                                        selectedColumnName !== null
                                            ? selectedColumnName
                                            : null
                                    }
                                    disabled={_.flatten([...(stash || []).map(item => typeof item.columnName === "string" ? item.columnName.split(", ") : item.columnName), ...(components || []).map(item => item.columnName)])}
                                    multipleSelection
                                    onSelect={({name}, multiplesAllowed) => onColumnSelect(name, multiplesAllowed)}
                                    showValueDefinitionButton={false}
                                    alwaysSelect={true}
                                />
                                <Tooltip
                                    title={t("scenes.mappingHandler.MappingSet.tooltip.showDatasetButton")}>
                                    <Button
                                        onClick={() => setShowDatasetPreview(true)}
                                        icon="table"
                                        disabled={!selectedDataset || !selectedDataset.columns}
                                        style={{width: '100%'}}>
                                        {t('data.csv.tableShowButton.label')}
                                    </Button>
                                </Tooltip>
                                <ObjectPreview connId={selectedConnection ? selectedConnection.entityId : null}
                                               query={selectedDataset ? selectedDataset.query : null}
                                               isRowsModalVisible={showDatasetPreview}
                                               onRowsModalHide={() => setShowDatasetPreview(false)}
                                               rows={rows}
                                               fetchRows={fetchTableViewPreviewRows}
                                               title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.dataset.previewAll')}
                                />
                            </div>
                        </Card>
                    </div>
                </Col>
                <Col span={10}>
                    <div style={{height: MAPPING_BLOCKS_HEIGHT}}>
                        <Card style={{height: "100%", minHeight: "300px"}}
                              bodyStyle={{height: "100%", minHeight: "300px"}}>
                            <MappingSetWizardComponentMapper/>
                        </Card>
                    </div>
                </Col>
                <Col span={7}>
                    <div style={{height: MAPPING_BLOCKS_HEIGHT}}>
                        <Card
                            title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.dsd.title')}
                            style={{height: "100%", minHeight: "300px"}}
                            bodyStyle={{height: "100%", minHeight: "300px"}}
                        >
                            <div style={{display: "flex", flexDirection: "column", height: "calc(100% - 40px)", gap: MARGIN_MD}}>
                                <MappingSetWizardComponentList
                                    hasIcon
                                    iconHasAction
                                    isDsd={true}
                                    components={
                                        dsd ? (
                                                dsd.map((component, idx) => ({
                                                    name: component.id,
                                                    key: idx,
                                                    assignmentStatus: component.assignmentStatus,
                                                    onIconAction:
                                                        component.id !== DOT_STAT_COLUMN_NAME
                                                            ? () => {
                                                                setAttribute(component);
                                                            }
                                                            : null,
                                                    onDetail: componentHasCodelist(component) ? () => onViewCodelistDetail(getArtefactTripletFromUrn(component.localRepresentation.enumeration)) : null,
                                                    iconDetailTitle: t('scenes.mappingHandler.MappingSet.wizard.steps.second.dsd.detail.title'),
                                                    detailTitle: componentHasCodelist(component) ? t('scenes.mappingHandler.MappingSet.wizard.steps.second.dsd.codelist.title') : null,
                                                    icon: component.icon
                                                }))
                                            )
                                            : []
                                    }
                                    selected={
                                        selectedDsdColumnName !== null
                                            ? selectedDsdColumnName
                                            : null
                                    }
                                    disabled={_.flatten([...(stash || []).map(item => item.dsdColumnName), ...(components || []).map(item => item.dsdColumnName)])}
                                    onSelect={({name}, multiplesAllowed) => onDsdColumnSelect(name, multiplesAllowed)}
                                    alwaysSelect={false}
                                />
                                <Tooltip
                                    title={t("scenes.mappingHandler.MappingSet.tooltip.showDsd")}>
                                    <Button
                                        onClick={() => onViewDsdDetail(dsdTriplet)}
                                        icon="table"
                                        disabled={!selectedDataset || !selectedDataset.columns}
                                        style={{width: '100%'}}>
                                        {t('scenes.mappingHandler.MappingSet.wizard.steps.second.dsd.tableShowButton.label')}
                                    </Button>
                                </Tooltip>
                            </div>
                        </Card>
                    </div>
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={21}>
                    <InfiniteScrollTable
                        height={TABLE_HEIGHT}
                        hideHeader
                        data={addStatusToStash(stash, t)}
                        columns={[{
                            title: t('scenes.mappingHandler.MappingSet.wizard.steps.second.table.datasetColumn'),
                            dataIndex: 'columnName',
                            render: columnName => separateWordsByComma(columnName),
                            renderText: columnName => separateWordsByComma(columnName),
                            minWidth: TABLE_COL_MIN_WIDTH_ID
                        },
                            {
                                title: t('scenes.mappingHandler.MappingSet.wizard.steps.second.table.dsdComponent'),
                                dataIndex: 'dsdColumnName',
                                minWidth: TABLE_COL_MIN_WIDTH_ID
                            },
                            {
                                title: t('scenes.mappingHandler.MappingSet.wizard.steps.second.table.status'),
                                dataIndex: 'status',
                                minWidth: TABLE_COL_MIN_WIDTH_ID
                            },]}
                        actions={[
                            (item) => (!!item.dsdCodelist || item.dsdType === 'TimeDimension' || !!item.constantValue || !item.hasOwnProperty("dsdCodelist")) ? ({
                                ...BUTTON_CREATE,
                                title: t('commons.buttons.create.title') + '/' + t('commons.buttons.edit.title'),
                                onClick: (item) => {
                                    checkSaveAndOpenModal(needsToBeSaved || needsToBeSavedSilently,
                                        !needsToBeSaved ? setShowSilentSaveAlert : setShowSaveAlert,
                                        () => setTranscodingToBeOpened(item),
                                        setSaveCallback)
                                }
                            }) : ({
                                ...BUTTON_BLANK,
                                disabled: true
                            }),
                            {
                                ...BUTTON_DELETE,
                                title: t('commons.actions.delete.title'),
                                onClick: (item, deselect) => Modal.confirm({
                                    title: t('scenes.mappingHandler.MappingSet.wizard.steps.second.messages.deleteStashRowPrompt', {
                                        column: item.dataset
                                    }),
                                    onOk() {
                                        deselect();
                                        onDeleteStashRow(item);
                                        if (item.entityId) {
                                            onDeleteMapping(item.entityId, item.dsdType === 'TimeDimension');
                                        }
                                    },
                                    cancelText: t('commons.buttons.cancel.title')
                                })
                            }
                        ]}
                    />
                </Col>
                <Col span={3} style={{display: "flex", flexDirection: "column", gap: GUTTER_SM,}}>
                    <Tooltip
                        placement="left"
                        title={t("scenes.mappingHandler.MappingSet.tooltip.mappingValidationButton")}>
                        <Button type="primary"
                                onClick={() => checkSaveAndOpenModal(true,
                                    !needsToBeSaved ? setShowSilentSaveAlert : setShowSaveAlert,
                                    () => setValidationAlert("mapping"), setSaveCallback)}>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.buttons.mappingValidation')}</Button>
                    </Tooltip>

                    <Tooltip
                        placement="left"
                        title={!isStruvalPresent ? t('scenes.mappingHandler.MappingSet.tooltip.struvalNeeded') : t("scenes.mappingHandler.MappingSet.tooltip.formatValidationButton")}>
                        <Button type="primary"
                                style={{width: '100%'}}
                                disabled={!isStruvalPresent}
                                onClick={() => checkSaveAndOpenModal(true,
                                    !needsToBeSaved ? setShowSilentSaveAlert : setShowSaveAlert,
                                    () => setValidationAlert("format"),
                                    setSaveCallback)
                                }>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.buttons.formatValidation')}</Button>
                    </Tooltip>

                    <Tooltip
                        placement="left"
                        title={t("scenes.mappingHandler.MappingSet.tooltip.dataValidationButton")}>
                        <Button type="primary"
                                onClick={() => checkSaveAndOpenModal(true,
                                    !needsToBeSaved ? setShowSilentSaveAlert : setShowSaveAlert,
                                    () => setValidationAlert("data"),
                                    setSaveCallback)
                                }>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.buttons.dataValidation')}</Button>
                    </Tooltip>

                    <Tooltip
                        placement="left"
                        title={t("scenes.mappingHandler.MappingSet.tooltip.datasetValidationButton")}>
                        <Button type="primary"
                                onClick={() => checkSaveAndOpenModal(true,
                                    !needsToBeSaved ? setShowSilentSaveAlert : setShowSaveAlert,
                                    () => setValidationAlert("dataset"),
                                    setSaveCallback)
                                }>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.buttons.datasetValidation')}</Button>
                    </Tooltip>

                    <Tooltip
                        placement="left"
                        title={t("scenes.mappingHandler.MappingSet.tooltip.viewMappedDataButton")}>
                        <Button
                            onClick={() => checkSaveAndOpenModal(true,
                                !needsToBeSaved ? setShowSilentSaveAlert : setShowSaveAlert,
                                () => setValidationAlert("preview"),
                                setSaveCallback)
                            }>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.buttons.viewMappedData')}</Button>
                    </Tooltip>
                </Col>
            </Row>
            <ModalPreview isRowsModalVisible={showMappingSetPreview}
                          onRowsModalHide={() => {
                              setShowMappingSetPreview(false);
                              clearPreview(mappingSetPreviewToken);
                          }}
                          rows={mappingSetPreview}
                          token={mappingSetPreviewToken}
            />
            <EnhancedModal
                visible={!!attribute}
                onCancel={() => setAttribute(null)}
                title={t('scenes.dataManager.builder.componensControl.attributeModal.title')}
                width={MODAL_WIDTH_SM}
                footer={<Button onClick={() => setAttribute(null)}>{t('commons.buttons.close.title')}</Button>}
            >
                {!!attribute && (
                    <AttributeDetailsMappingSet
                        attribute={attribute}
                    />
                )}
            </EnhancedModal>
            {codelistDetail && <ReduxCodelistDetailModal
                instancePrefix={MM_CODELISTS_PREFIX}
                instanceState={{
                    ...codelistDetail,
                    isEditDisabled: true,
                    currentTab: codelistTab,
                    onForcedTabChange: (tab) => setCodelistTab(tab)
                }}
            />}
            {dsdDetail && <ReduxDsdDetailModal
                instancePrefix={MM_DSDS_PREFIX}
                instanceState={{...dsdDetail, isEditDisabled: true}}
            />}
            <ValidationAlert onHide={() => setValidationAlert(null)} isVisible={!!validationAlert}
                             type={validationAlert} openPreviewCallback={() => setShowMappingSetPreview(true)}/>
            <SaveMappingWithNameAlert onHide={() => setShowSaveAlert(false)} isVisible={showSaveAlert}
                                      callback={saveCallback}/>
            <SaveMappingWithNameAlert onHide={() => setShowSilentSaveAlert(false)} isVisible={showSilentSaveAlert}
                                      callback={saveCallback} silent={true}/>
            <TranscodingDimension/>
            <TranscodingTimeDimension/>
            <Simple01Transcoding/>
        </Fragment>

    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(MappingSetDefinition);